import { render } from "./ProfileStatsExperience.vue?vue&type=template&id=3d191c2c&scoped=true"
import script from "./ProfileStatsExperience.vue?vue&type=script&lang=js"
export * from "./ProfileStatsExperience.vue?vue&type=script&lang=js"

import "./ProfileStatsExperience.vue?vue&type=style&index=0&id=3d191c2c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d191c2c"]])

export default __exports__